export const environment = {
    production: false,
    msalConfig: {
        auth: {
            clientId: '##MonitoringClientId##',
            authority: 'https://login.microsoftonline.com/groupsolina.onmicrosoft.com'
        }
    },
    apiConfig: {
        scopes: ['##MonitoringScopes##'],
        uri: '##MonitoringAuthId##',
        api: '##MonitoringApi##'
        
    }
};